(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-review"] && !Shopify.designMode) return;
  try {
    
function gccvSetupReviews() {
  document.querySelectorAll('[data-gccv-reviews]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const track = section.querySelector('.review-carousel');
    section.querySelectorAll('[data-review-direction]').forEach(button => button.addEventListener('click', () => {
      track.scrollBy({left: Number(button.dataset.reviewDirection) * (track.clientWidth + 24), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
  });
}
gccvSetupReviews();
document.addEventListener('shopify:section:load', gccvSetupReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var grid = document.querySelector('#story-gallery');
  updateMasonry(grid); // Initialize Masonry on page load

  window.addEventListener('resize', function() {
    resetMasonry(grid); // Update Masonry on window resize
  });
});

function updateMasonry(grid) {
  var gridColumnWidth = calculateGridColumnWidth(grid);
  new Masonry(grid, {
    itemSelector: '.masonry-item',
    columnWidth: gridColumnWidth,
    percentPosition: true
  });
}

function calculateGridColumnWidth(grid) {
  var columnCount = 4; // Default column count for desktop
  if (grid.classList.contains('four-columns')) columnCount = 4;
  if (grid.classList.contains('six-columns')) columnCount = 6;
  if (grid.classList.contains('eight-columns')) columnCount = 8;

  // Adjust for mobile
  if (window.innerWidth <= 768) {
    if (grid.classList.contains('two-mobile-columns')) columnCount = 2;
    if (grid.classList.contains('three-mobile-columns')) columnCount = 3;
    if (grid.classList.contains('four-mobile-columns')) columnCount = 4;
  }

  return grid.offsetWidth / columnCount;
}

function resetMasonry(grid) {
  // Destroy the existing Masonry instance before reinitializing
  if (grid.masonry) {
    grid.masonry.destroy();
  }
  updateMasonry(grid);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-background"] && !Shopify.designMode) return;
  try {
    
function gccvSetupVideo() {
  document.querySelectorAll('[data-gccv-video-toggle]').forEach(button => {
    if (button.dataset.ready) return;
    const video = document.getElementById(button.getAttribute('aria-controls'));
    if (!video) return;
    button.dataset.ready = 'true';
    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let wantsPlayback = !reducedMotion.matches;
    const sync = () => {
      button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
      button.classList.toggle('is-paused', video.paused);
      button.hidden = false;
    };
    const start = () => {
      if (!wantsPlayback || document.hidden) return;
      video.play().then(sync).catch(sync);
    };
    video.autoplay = wantsPlayback;
    if (wantsPlayback) start(); else { video.pause(); sync(); }
    video.addEventListener('canplay', start, {once:true});
    button.addEventListener('click', () => {
      wantsPlayback = video.paused;
      if (wantsPlayback) start(); else video.pause();
    });
    video.addEventListener('playing', sync);
    video.addEventListener('pause', sync);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) start(); });
    reducedMotion.addEventListener('change', event => {
      if (event.matches) { wantsPlayback = false; video.pause(); sync(); }
    });
  });
}
gccvSetupVideo();
document.addEventListener('shopify:section:load', gccvSetupVideo);

  } catch(e) { console.error(e); }
})();
})();
